var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechBuzzShorts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.096,
    height: 21.202,
    viewBox: "0 0 31.096 21.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e76d10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7ac4c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line",
    transform: "translate(-2 -9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M33.1,11.12A2.123,2.123,0,0,0,30.976,9H4.12A2.123,2.123,0,0,0,2,11.12v2.12H33.1ZM5.548,12.534a.707.707,0,0,1-.007-1.413h.007a.707.707,0,1,1,0,1.413Zm2.827,0a.707.707,0,0,1-.007-1.413h.007a.707.707,0,1,1,0,1.413Zm2.827,0a.707.707,0,0,1-.007-1.413H11.2a.707.707,0,0,1,0,1.413Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M2,17V30.428a2.123,2.123,0,0,0,2.12,2.12H30.976a2.123,2.123,0,0,0,2.12-2.12V17Zm12.329,9.069-2.12-1.413a.72.72,0,0,1,0-1.176l2.12-1.413a.707.707,0,0,1,.784,1.176l-1.237.825,1.238.825A.707.707,0,1,1,14.329,26.069Zm2.438,1.141a.707.707,0,0,1-1.264-.633l2.827-5.654a.707.707,0,0,1,1.264.633Zm6.088-2.555-2.12,1.413a.707.707,0,1,1-.784-1.176l1.238-.825-1.238-.825a.707.707,0,0,1,.784-1.176l2.12,1.413A.72.72,0,0,1,22.855,24.655Z",
    transform: "translate(0 -2.346)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechBuzzShorts);
export default __webpack_public_path__ + "static/media/techBuzzShorts.4dddd66293c1ccb5c3d2e5e515b27346.svg";
export { ForwardRef as ReactComponent };